import React from "react";
import { Card, Box, Typography, CardContent, Grid, FormControl, InputLabel, Select, MenuItem, FormHelperText } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

// D8.5.4 — Sección "Zona horaria para campañas" (presentacional).
export default function OptionsTimezoneSection({ classes, loadingTimezones, timezones, timezoneType, handleChangeTimezone, loadingTimezoneType }) {
  return (
          <Card className={classes.sectionCard}>
            <Box className={classes.sectionHeader}>
              <Typography className={classes.sectionTitle}>
                <span role="img" aria-label={i18n.t("settings.options.timezoneForCampaigns")}>🌍</span> {i18n.t("settings.options.timezoneForCampaigns")}
              </Typography>
            </Box>
            <CardContent className={classes.sectionContent}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Box className={classes.settingItem}>
                    <Typography className={classes.settingLabel}>
                      <span role="img" aria-label={i18n.t("settings.options.timezoneForCampaigns")}>🌍</span> {i18n.t("settings.options.timezoneForCampaigns")}
                    </Typography>
                    <Typography className={classes.settingDescription}>
                      {i18n.t("settings.options.timezoneForCampaignsDesc")}
                    </Typography>
                    <FormControl className={classes.formControl} variant="outlined" fullWidth>
                      <InputLabel>{i18n.t("settings.options.timezone")}</InputLabel>
                      <Select
                        value={loadingTimezones || timezones.length === 0 ? "" : timezoneType}
                        onChange={(e) => handleChangeTimezone(e.target.value)}
                        label={i18n.t("settings.options.timezone")}
                        disabled={loadingTimezones || timezones.length === 0}
                      >
                        {loadingTimezones ? (
                          <MenuItem value="" disabled>{i18n.t("settings.options.loadingTimezones")}</MenuItem>
                        ) : timezones.length > 0 ? (
                          // ✅ DB-FIRST: Renderizar dinámicamente desde la base de datos
                          timezones.map((tz) => (
                            <MenuItem key={tz.id || tz.timezone} value={tz.timezone}>
                              {tz.displayName}
                            </MenuItem>
                          ))
                        ) : (
                          // Fallback: Lista mínima si no hay datos
                          <>
                            <MenuItem value="America/Lima">{i18n.t("settings.options.timezoneQuickPeru")}</MenuItem>
                            <MenuItem value="America/Bogota">{i18n.t("settings.options.timezoneQuickColombia")}</MenuItem>
                          </>
                        )}
                      </Select>
                      {loadingTimezoneType && (
                        <FormHelperText className={classes.loadingText}>
                          {i18n.t("settings.states.updating")}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
  );
}
